import { Box, FormControl, FormControlLabel, Grid,  RadioGroup, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import TestCaseHeader from '../testCaseHeader';
import BroadcastDropdown from './BroadcastDropdown';
import MUIButton from '../../shared/components/MUIButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RtnDropdown from './RtnDropdown';
import { Input, Modal, Radio, Space } from 'antd';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useGetAdmi004MessageTypesQuery, useSystemMessageRequestMutation, useSystemMessageResponseMutation } from '../../redux/Reports/reports.api';
import _ from 'lodash';
import { SnackbarContext } from '../../shared/context/SnackbarContext.Context';
import { ALERT_SEVERITY } from '../../shared/constants/constants';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useSelector } from 'react-redux';
import { DropdownValueContext } from '../../shared/context/DropdownProvider';
import AdministrationDropdown from './AdministrationDropdown';

const AdministrationRequest = () => {
    const { TextArea } = Input;
    const { customerId } = useSelector((state) => state?.common);
    const { userRole } = useSelector((state) => state?.common?.userDetails);
    const Snackbar = useContext(SnackbarContext);
    const {  customer, value } = useContext(DropdownValueContext);
    const PaymentServicePayload = {
       paymentServiceId:value
    }
    const data = useGetAdmi004MessageTypesQuery(PaymentServicePayload);
    const [selectedValue, setSelectedValue] = useState({});
    const [broadMsg, setBroadMsg] = useState();
    const [broadViewMsg, setBroadViewMsg] = useState();
    const [rtnNum, setRtnNum] = useState();
    const [isModalVisible, setModalVisibility] = useState(false);
    const [systemRequestGeneration] = useSystemMessageRequestMutation();
    const [systemResponse] = useSystemMessageResponseMutation();
    const [rtnRes, setRtnRes] = useState();
    const [admi004RetriveId, setAdmi004RetriveId] = useState();
    const [valuee, setValue] = useState([]);
    const MAX_RETRIES = 5;

    useEffect(()=>{
        if(data?.data){
        setSelectedValue(data?.data[0])
        }
    },[data])

    const handleReportChange = (event) => {
        // Update the state when a different radio button is selected
        setSelectedValue(event.target.value);
    };

    const onBroadCastSelection = (event) => {
        setBroadMsg(event)
    };
    const onBroadCastViewSelection = (event) => {
        setBroadViewMsg(event)
    };
    const onRTNSelection = (e) => {
        setRtnNum(e)
    };
    
    const responsePayload = {
        messageTypeName:selectedValue?.messageTypeName,
        boardcastMessageTypeName:broadViewMsg,
        customerId:(userRole?.name === 'Admin' || userRole?.name === 'Tester') ? customerId : customer,
        rtn:rtnRes ? [rtnRes] : null,
        admi004RetriveIds:admi004RetriveId,
        paymentServiceId:value
    }
    
    const responseFetch=(attempt = 1)=>{
        systemResponse(responsePayload).then(res => {
            console.log("responsePayloadCCC",res);
            if (res?.error?.status === 400) {
                Snackbar.displayMsg("Response was Failed", ALERT_SEVERITY.ERROR)
            } else if (res?.data?.data?.length === 0) {
                Snackbar.displayMsg("No data received", ALERT_SEVERITY.ERROR);
            }else if (res?.data?.data[0]?.responseXML=== null) {
                if (attempt < MAX_RETRIES) {
                    setTimeout(() => responseFetch(attempt + 1), 2000); 
                } else {
                    setValue(res?.data?.data[0]?.responseXML);
                }
            } else {
                setValue(res?.data?.data[0]?.responseXML);
            }
           })
    }
    useEffect(() => {
        if (isModalVisible !==false) {
            responseFetch();
        }
    },[isModalVisible])

    const systemMessagePayload = {
        messageTypeName:selectedValue?.messageTypeName,
        boardcastMessageTypeName:broadViewMsg,
        customerId:(userRole?.name === 'Admin' || userRole?.name === 'Tester') ? customerId : customer,
        paymentServiceId:value
    }
    if (selectedValue?.messageTypeName === 'Participant Broadcast'  && rtnNum !== "") {
        systemMessagePayload.rtn = rtnNum ? rtnNum : null;
    }
   
    const handleGenerate = async(isVisible) => {
        if (selectedValue?.messageTypeName === 'Participant Broadcast' ? broadMsg === undefined : broadViewMsg === undefined) {
           Snackbar.displayMsg("Please Select the Broadcast Message",ALERT_SEVERITY.ERROR);
           return; 
        }
         else {
            await systemRequestGeneration(systemMessagePayload).then(res => {
                console.log("Res", res);
                if (res?.data?.status === "success") {
                    Snackbar.displayMsg(res?.data?.message, ALERT_SEVERITY.SUCCESS);
                    setAdmi004RetriveId(res?.data?.admi004RetriveId);
                    setRtnRes(res?.data?.rtn);
                    setTimeout(() => {
                        setModalVisibility(isVisible);
                    }, 5000);
                } else if(res?.error?.status === 400){
                    Snackbar.displayMsg(res?.error?.data?.message, ALERT_SEVERITY.ERROR);  
                }else {
                    Snackbar.displayMsg("Failed to Generate System Message",ALERT_SEVERITY.ERROR);
                }
            })
           
        }
        
    };

    const onCancel = () => {
        setModalVisibility(false)
    };

    const downloadFile = () => {
        if (valuee) {
            const element = document.createElement("a");
            const file = new Blob([valuee], { type: 'text/plain' });
            element.href = URL.createObjectURL(file);
            element.download = 
                (selectedValue?.messageTypeName === "Participant Broadcast" ? `Admi.004-${broadMsg}` : `Admi.004-${broadViewMsg}`)
            document.body.appendChild(element);
            element.click();
            setModalVisibility(true)   
        } else {
          Snackbar.displayMsg("No data to download",ALERT_SEVERITY.ERROR);  
        } 
    };
    return (
        <Box sx={{ overflowY: 'auto', height: `calc(100vh - 100px)`, paddingBottom: "30px" }}>
            <TestCaseHeader
                title="Administration Messages"
                showTestCustomer={{
                    show: true,
                }}
                showCustomer={{ show: false,  }}
            />

            <Box sx={{ px: '2.1%', py:'5%' }}>
                    <Box sx={{ px: '3.5%' }}>
                        <Box>
                            <Grid container>
                                <Grid item width={"40%"} mt={1}>
                                    <Typography sx={{ display: "flex", fontFamily: 'Inter', fontStyle: 'normal', fontWeight: "bold", fontSize: "17px" }}>
                                        Select Administration Message
                                    </Typography>
                                </Grid>
                                <Grid item mt={3}>
                                   
                                    <AdministrationDropdown onChangeBroadCast={onBroadCastViewSelection} value={broadViewMsg} paymentValue={value}/>
                                </Grid>
                            </Grid>
                        </Box>

                    </Box>
            </Box>
            <Box mt={"15%"} sx={{ display: "flex", px: '2.1%' }}>
                <MUIButton
                    startIcon={<CheckCircleIcon style={{ fontSize: 18, }} />}
                    title="Generate"
                    onClick={handleGenerate}
                />
            </Box>

            <Modal
                onCancel={onCancel}
                open={isModalVisible} footer={[]}
                closeIcon={<CancelOutlinedIcon style={{ color: "#001A11", backgroundColor: "white" }} />}
                destroyOnClose
                width={"70%"}
                maskClosable={false}
            >
                <Box>
                    <TestCaseHeader 
                    title={(broadViewMsg === "Sign-On" ? `Admn.001-${broadViewMsg}` :broadViewMsg === "Sign-Off"? `Admn.003-${broadViewMsg}`:broadViewMsg === "Echo"? `Admn.005-${broadViewMsg}`:`Admn.007-${broadViewMsg}`)}

                    showFileUpload={{
                        show: true,
                        customIcon: <FileDownloadIcon />,
                        onClick: () => downloadFile()
                    }}
                    // showRefresh={{
                    //     show: false,
                    //     onClick: handleRefreshButton
                    // }}
                    />
                    {/* <WrapperComponent isSuccess={isSuccess} isFetching={isLoading}> */}
                    <div style={{ marginTop: 5 }}>

                        <TextArea
                            className="xml-txt-area"
                            rows={15}
                            readOnly
                            style={{ height: '100%' }}
                        // value={value.length > 0 ? value[startIndex]?.response : 'IN PROGRESS'} // Display the response based on the current page
                            value={valuee === null ? "NO DATA" : valuee}
                        />


                        {/* <div style={{ marginTop: 4, display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                            
                            <Pagination
                                current={currentPage}
                                pageSize={itemsPerPage}
                                total={value?.length}
                                onChange={changePage}
                                hideOnSinglePage={true}
                            />
                           
                        </div> */}

                    </div>

                </Box>

            </Modal>
        </Box>
    )
}

export default AdministrationRequest;